// Client-side matching for the Rider-Driver Exclusions registry against trip
// data (HITCH-5300). Keys on the Mongo user `_id` on both sides — the
// registry's own `riderMongoId`/`driverMongoId` fields — matching the `id`
// field GraphQL resolves on `trip.driver` and `trip.rides[].rider`. NOT
// `driver_id`/`rider_id`, which are separate, nullable Postgres uuids that
// won't match the registry.
export const exclusionKey = (driverId, riderId) => `${driverId}:${riderId}`;

export const buildExclusionMatchSet = (exclusions) =>
  new Set((exclusions || []).map((e) => exclusionKey(e.driverMongoId, e.riderMongoId)));

// Given a trip's driver id and its riders, returns the subset of rider ids
// excluded with that driver. Empty for an unclaimed trip (`driverId` falsy) —
// an unclaimed trip has no formed pairing to flag.
export const getExcludedRiderIds = (driverId, riders, matchSet) => {
  const excluded = new Set();
  if (!driverId || !matchSet || matchSet.size === 0) return excluded;
  (riders || []).forEach((rider) => {
    if (rider?.id && matchSet.has(exclusionKey(driverId, rider.id))) {
      excluded.add(rider.id);
    }
  });
  return excluded;
};
